import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';

import {AfterViewInit, ChangeDetectionStrategy, Component, DOCUMENT, HostListener, Inject} from '@angular/core';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {filter} from 'rxjs/internal/operators/filter';
import {WINDOW} from '../../services/windows.service';
import {TranslatePipe} from "@ngx-translate/core";
import {NgClass} from "@angular/common";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {AppLanguage, LanguageService} from "../../services/language.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    imports: [
        RouterLink,
        TranslatePipe,
        NgClass,
        MatButtonToggle,
        MatButtonToggleGroup
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterViewInit {
    public activeClass = 'day';
    public darkHeader = false;
    public isOpenMobile = false;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(WINDOW) private window: Window,
        public breakpointObserver: BreakpointObserver,
        private router: Router,
        public languageService: LanguageService
    ) {
        this.router.events.pipe(
            filter((event: any) => event instanceof NavigationEnd)
        ).subscribe(event => {
            const url: string = event.url.replace(/^\/en(?=\/)/, '').replace('/', '');
            if (url.length <= 0 || url.includes('day')) {
                this.activeClass = 'day';
            } else {
                this.activeClass = url;
            }
        });
    }

    ngAfterViewInit() {
    }

    active(val: any) {
        this.activeClass = val;
        this.isOpenMobile = false;
    }

    // @HostListener Decorator
    @HostListener('window:scroll')
    onWindowScroll() {
        const number = this.window.pageYOffset || this.document.documentElement.scrollTop || this.document.body.scrollTop || 0;
        this.darkHeader = number >= 60;
        this.breakpointObserver
            .observe(['(min-width: 991px)'])
            .subscribe((_: BreakpointState) => {
                this.activeClass = 'contact';
            });
    }

    get language(): AppLanguage {
        return this.languageService.current();
    }

    protected setLanguage(language: AppLanguage) {
        const currentUrl = this.router.url;
        const germanUrl = currentUrl === '/en' ? '/' : currentUrl.replace(/^\/en(?=\/)/, '');
        const targetUrl = language === 'en' ? `/en${germanUrl}` : germanUrl;

        this.router.navigateByUrl(targetUrl);
    }

}
